import React, { useState, useEffect } from 'react';
import paymentService from '../services/payment';
import utils from '../utils/utils';
import { NavLink, Redirect } from "react-router-dom";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import {swalError} from "../utils/swal";
import PurchaseItem from "./PurchaseItem";

function Purchases({ session, setKey, ...props }) {

    const [rows, setRows] = useState([]);

    useEffect(() => {
        reload();
    }, []);

	const render = () => {
		if (!rows || rows.length === 0) {
			return <tr><td className="mt-10" colSpan={4}>No items found.</td></tr>
		}

		return rows.map((k, idx) => <PurchaseItem data={k} key={k._id} idx={idx+1} />);
	}

    const reload = () => {
        paymentService.getByUser(session.token)
            .then(result => {
                if (result.error) {
                    swalError(result.error);
                    return;
                }
                setRows(result.data);
            });
    }

    return (
        <>
			<p className="cart-title mt-10">My Purchases</p>
			{render()}
        </>
    );
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Purchases);
